/**
 * @module signup
 *
 * Handles embedded signup form from marketing website. Also manipulates
 * whether this customer is on No-CC flow or not. There are two ways of doing this:
 *
 * 1. Use ?trial=now in the query string (to get NoCC flow)
 * 2. Use trial = 'now' in your frontmatter (to get NoCC flow)
 *
 * Alterantively, instead of 'now' you can use 'cc' to force CC capturing instead.
 */

function forceNoCCFlow() {
  document.cookie = 'use_no_cc_flow=1; path=/; samesite=strict;'
}

function forceCCFlow() {
  document.cookie =
    'use_no_cc_flow=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; samesite=strict';
}

export default function initSignupFunctionality() {
  const trialMetaTag = document.querySelector('meta[name="olark:trial"]')
  const trialMetaTagValue = trialMetaTag
    ? trialMetaTag.getAttribute('content')
    : null
  const queryString = document.location.search

  const noCCRequestedInUrl = /trial=now/.test(queryString)
  const noCCRequestedInMetaTags = trialMetaTagValue === 'now'

  const ccRequestedInUrl = /trial=cc/.test(queryString)
  const ccRequestedInMetaTags = trialMetaTagValue === 'cc'

  if (noCCRequestedInUrl) {
    forceNoCCFlow()
  } else if (ccRequestedInUrl) {
    forceCCFlow()
  } else if (noCCRequestedInMetaTags) {
    forceNoCCFlow()
  } else if (ccRequestedInMetaTags) {
    forceCCFlow()
  }
}
